//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { useAppContext } from "./AppContext";
import * as msal from "@azure/msal-browser";
import { msalInstance } from ".";
export class ClientBase {

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        await msalInstance.acquireTokenSilent({
            scopes: [
                "api://" + process.env["REACT_APP_APP_ID"] + "/access_as_user"]
        }).then(result => {
            options.headers = {
                ...options.headers,
                Authorization: 'Bearer ' + result.idToken,
            };

        })
        return Promise.resolve(options);

    };
}

export class CaseClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createNewCase(body: CreateCaseDTO | undefined): Promise<CaseDTO> {
        let url_ = this.baseUrl + "/Case/CreateNewCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewCase(_response);
        });
    }

    protected processCreateNewCase(response: Response): Promise<CaseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateExistingCase(body: CreateCaseDTO | undefined): Promise<CaseDTO> {
        let url_ = this.baseUrl + "/Case/UpdateExistingCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateExistingCase(_response);
        });
    }

    protected processUpdateExistingCase(response: Response): Promise<CaseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO>(null as any);
    }

    /**
     * @param localOfficeId (optional) 
     * @return Success
     */
    getLocalOfficeCases(localOfficeId: number | undefined): Promise<CaseDTO[]> {
        let url_ = this.baseUrl + "/Case/GetLocalOfficeCases?";
        if (localOfficeId === null)
            throw new Error("The parameter 'localOfficeId' cannot be null.");
        else if (localOfficeId !== undefined)
            url_ += "localOfficeId=" + encodeURIComponent("" + localOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocalOfficeCases(_response);
        });
    }

    protected processGetLocalOfficeCases(response: Response): Promise<CaseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO[]>(null as any);
    }

    /**
     * @param resettlementAgencyId (optional) 
     * @return Success
     */
    getResettlementAgencyCases(resettlementAgencyId: number | undefined): Promise<CaseDTO[]> {
        let url_ = this.baseUrl + "/Case/GetResettlementAgencyCases?";
        if (resettlementAgencyId === null)
            throw new Error("The parameter 'resettlementAgencyId' cannot be null.");
        else if (resettlementAgencyId !== undefined)
            url_ += "resettlementAgencyId=" + encodeURIComponent("" + resettlementAgencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResettlementAgencyCases(_response);
        });
    }

    protected processGetResettlementAgencyCases(response: Response): Promise<CaseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllCases(): Promise<CaseDTO[]> {
        let url_ = this.baseUrl + "/Case/GetAllCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCases(_response);
        });
    }

    protected processGetAllCases(response: Response): Promise<CaseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCase(body: CaseDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Case/UpdateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCase(_response);
        });
    }

    protected processUpdateCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getVolunteerCases(body: GetVolunteerCasesDTO | undefined): Promise<CaseDTO[]> {
        let url_ = this.baseUrl + "/Case/GetVolunteerCases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVolunteerCases(_response);
        });
    }

    protected processGetVolunteerCases(response: Response): Promise<CaseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseDTO[]>(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCase(caseId: number | undefined): Promise<CreateCaseDTO> {
        let url_ = this.baseUrl + "/Case/GetCase?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCase(_response);
        });
    }

    protected processGetCase(response: Response): Promise<CreateCaseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseDTO>(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCaseCaseVolunteers(caseId: number | undefined): Promise<CaseVolunteerDTO[]> {
        let url_ = this.baseUrl + "/Case/GetCaseCaseVolunteers?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseCaseVolunteers(_response);
        });
    }

    protected processGetCaseCaseVolunteers(response: Response): Promise<CaseVolunteerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseVolunteerDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseVolunteerDTO[]>(null as any);
    }

    /**
     * @param sponsorshipGroupId (optional) 
     * @return Success
     */
    getCaseSponsorshipGroup(sponsorshipGroupId: number | undefined): Promise<CaseVolunteerDTO> {
        let url_ = this.baseUrl + "/Case/GetCaseSponsorshipGroup?";
        if (sponsorshipGroupId === null)
            throw new Error("The parameter 'sponsorshipGroupId' cannot be null.");
        else if (sponsorshipGroupId !== undefined)
            url_ += "sponsorshipGroupId=" + encodeURIComponent("" + sponsorshipGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseSponsorshipGroup(_response);
        });
    }

    protected processGetCaseSponsorshipGroup(response: Response): Promise<CaseVolunteerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseVolunteerDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseVolunteerDTO>(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCaseFamilyMembers(caseId: number | undefined): Promise<FamilyMemberDTO[]> {
        let url_ = this.baseUrl + "/Case/GetCaseFamilyMembers?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseFamilyMembers(_response);
        });
    }

    protected processGetCaseFamilyMembers(response: Response): Promise<FamilyMemberDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FamilyMemberDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FamilyMemberDTO[]>(null as any);
    }
}

export class CaseActivityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCaseActivities(caseId: number | undefined): Promise<CreateCaseActivityDTO[]> {
        let url_ = this.baseUrl + "/CaseActivity/GetCaseActivities?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseActivities(_response);
        });
    }

    protected processGetCaseActivities(response: Response): Promise<CreateCaseActivityDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseActivityDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseActivityDTO[]>(null as any);
    }

    /**
     * @param caseActivityId (optional) 
     * @return Success
     */
    getCaseActivityForEdit(caseActivityId: number | undefined): Promise<CreateCaseActivityDTO> {
        let url_ = this.baseUrl + "/CaseActivity/GetCaseActivityForEdit?";
        if (caseActivityId === null)
            throw new Error("The parameter 'caseActivityId' cannot be null.");
        else if (caseActivityId !== undefined)
            url_ += "caseActivityId=" + encodeURIComponent("" + caseActivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseActivityForEdit(_response);
        });
    }

    protected processGetCaseActivityForEdit(response: Response): Promise<CreateCaseActivityDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseActivityDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseActivityDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createCaseActivity(body: CreateCaseActivityDTO | undefined): Promise<CreateCaseActivityDTO> {
        let url_ = this.baseUrl + "/CaseActivity/CreateCaseActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseActivity(_response);
        });
    }

    protected processCreateCaseActivity(response: Response): Promise<CreateCaseActivityDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseActivityDTO;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseActivityDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseActivity(body: CreateCaseActivityDTO | undefined): Promise<number> {
        let url_ = this.baseUrl + "/CaseActivity/UpdateCaseActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCaseActivity(_response);
        });
    }

    protected processUpdateCaseActivity(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CaseActivityBlobClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param caseNumber (optional) 
     * @param file (optional) 
     * @return Created
     */
    uploadBlob(caseNumber: string | undefined, file: FileParameter | undefined): Promise<BlobUploadDTO> {
        let url_ = this.baseUrl + "/CaseActivityBlob/UploadBlob?";
        if (caseNumber === null)
            throw new Error("The parameter 'caseNumber' cannot be null.");
        else if (caseNumber !== undefined)
            url_ += "caseNumber=" + encodeURIComponent("" + caseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadBlob(_response);
        });
    }

    protected processUploadBlob(response: Response): Promise<BlobUploadDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlobUploadDTO;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobUploadDTO>(null as any);
    }

    /**
     * @param filePath (optional) 
     * @return Success
     */
    getBlob(filePath: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/CaseActivityBlob/GetBlob?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBlob(_response);
        });
    }

    protected processGetBlob(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CaseActivityCheckboxClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param section (optional) 
     * @return Success
     */
    getActivityCheckboxesBySection(section: string | undefined): Promise<CaseActivityCheckboxDTO[]> {
        let url_ = this.baseUrl + "/CaseActivityCheckbox/GetActivityCheckboxesBySection?";
        if (section === null)
            throw new Error("The parameter 'section' cannot be null.");
        else if (section !== undefined)
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityCheckboxesBySection(_response);
        });
    }

    protected processGetActivityCheckboxesBySection(response: Response): Promise<CaseActivityCheckboxDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseActivityCheckboxDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseActivityCheckboxDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLocalActivityCheckboxesBySection(body: LocalOfficeActivityCheckboxBySectionDTO | undefined): Promise<CaseActivityCheckboxDTO[]> {
        let url_ = this.baseUrl + "/CaseActivityCheckbox/GetLocalActivityCheckboxesBySection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocalActivityCheckboxesBySection(_response);
        });
    }

    protected processGetLocalActivityCheckboxesBySection(response: Response): Promise<CaseActivityCheckboxDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseActivityCheckboxDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseActivityCheckboxDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActivityCheckboxesByIds(body: number[] | undefined): Promise<CaseActivityCheckboxDTO[]> {
        let url_ = this.baseUrl + "/CaseActivityCheckbox/GetActivityCheckboxesByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActivityCheckboxesByIds(_response);
        });
    }

    protected processGetActivityCheckboxesByIds(response: Response): Promise<CaseActivityCheckboxDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseActivityCheckboxDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseActivityCheckboxDTO[]>(null as any);
    }
}

export class CountryClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCountries(): Promise<CountryDTO[]> {
        let url_ = this.baseUrl + "/Country/GetAllCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCountries(_response);
        });
    }

    protected processGetAllCountries(response: Response): Promise<CountryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDTO[]>(null as any);
    }
}

export class EducationLevelClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<EducationLevelDTO[]> {
        let url_ = this.baseUrl + "/EducationLevel/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<EducationLevelDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducationLevelDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationLevelDTO[]>(null as any);
    }
}

export class EmbedInfoClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmbedInfo(body: EmbedInfoDTO | undefined): Promise<EmbedParams> {
        let url_ = this.baseUrl + "/EmbedInfo/GetEmbedInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmbedInfo(_response);
        });
    }

    protected processGetEmbedInfo(response: Response): Promise<EmbedParams> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmbedParams;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmbedParams>(null as any);
    }
}

export class EmploymentTypeClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<EmploymentTypeDTO[]> {
        let url_ = this.baseUrl + "/EmploymentType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<EmploymentTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentTypeDTO[]>(null as any);
    }
}

export class EngagementCountClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<EngagementCountDTO[]> {
        let url_ = this.baseUrl + "/EngagementCount/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<EngagementCountDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EngagementCountDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EngagementCountDTO[]>(null as any);
    }
}

export class EthnicityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<EthnicityDTO[]> {
        let url_ = this.baseUrl + "/Ethnicity/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<EthnicityDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EthnicityDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EthnicityDTO[]>(null as any);
    }
}

export class GenderClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<GenderDTO[]> {
        let url_ = this.baseUrl + "/Gender/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<GenderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenderDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenderDTO[]>(null as any);
    }
}

export class ImmigrationStoryClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Promise<ImmigrationStoryDTO[]> {
        let url_ = this.baseUrl + "/ImmigrationStory/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ImmigrationStoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImmigrationStoryDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImmigrationStoryDTO[]>(null as any);
    }
}

export class LanguageClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLanguages(): Promise<LanguageDTO[]> {
        let url_ = this.baseUrl + "/Language/GetAllLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllLanguages(_response);
        });
    }

    protected processGetAllLanguages(response: Response): Promise<LanguageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LanguageDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDTO[]>(null as any);
    }
}

export class LocalOfficeClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLocalOffices(): Promise<LocalOfficeDTO[]> {
        let url_ = this.baseUrl + "/LocalOffice/GetAllLocalOffices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllLocalOffices(_response);
        });
    }

    protected processGetAllLocalOffices(response: Response): Promise<LocalOfficeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeDTO[]>(null as any);
    }

    /**
     * @param resettlementAgencyId (optional) 
     * @return Success
     */
    getByResettlementAgencyId(resettlementAgencyId: number | undefined): Promise<LocalOfficeDTO[]> {
        let url_ = this.baseUrl + "/LocalOffice/GetByResettlementAgencyId?";
        if (resettlementAgencyId === null)
            throw new Error("The parameter 'resettlementAgencyId' cannot be null.");
        else if (resettlementAgencyId !== undefined)
            url_ += "resettlementAgencyId=" + encodeURIComponent("" + resettlementAgencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByResettlementAgencyId(_response);
        });
    }

    protected processGetByResettlementAgencyId(response: Response): Promise<LocalOfficeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeDTO[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocalOffice(id: number | undefined): Promise<LocalOfficeDTO> {
        let url_ = this.baseUrl + "/LocalOffice/GetLocalOffice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocalOffice(_response);
        });
    }

    protected processGetLocalOffice(response: Response): Promise<LocalOfficeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeDTO>(null as any);
    }

    /**
     * @param localOfficeId (optional) 
     * @return No Content
     */
    removeLocalOffice(localOfficeId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LocalOffice/RemoveLocalOffice?";
        if (localOfficeId === null)
            throw new Error("The parameter 'localOfficeId' cannot be null.");
        else if (localOfficeId !== undefined)
            url_ += "localOfficeId=" + encodeURIComponent("" + localOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveLocalOffice(_response);
        });
    }

    protected processRemoveLocalOffice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createLocalOffice(body: CreateLocalOfficeDTO | undefined): Promise<LocalOfficeDTO> {
        let url_ = this.baseUrl + "/LocalOffice/CreateLocalOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocalOffice(_response);
        });
    }

    protected processCreateLocalOffice(response: Response): Promise<LocalOfficeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeDTO;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editLocalOffice(body: LocalOfficeDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LocalOffice/EditLocalOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditLocalOffice(_response);
        });
    }

    protected processEditLocalOffice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LocalOfficeCaseActivityCheckboxClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param localOfficeId (optional) 
     * @return Success
     */
    getCaseActivitiesForLocalOffice(localOfficeId: number | undefined): Promise<LocalOfficeCaseActivityCheckboxDTO[]> {
        let url_ = this.baseUrl + "/LocalOfficeCaseActivityCheckbox/GetCaseActivitiesForLocalOffice?";
        if (localOfficeId === null)
            throw new Error("The parameter 'localOfficeId' cannot be null.");
        else if (localOfficeId !== undefined)
            url_ += "localOfficeId=" + encodeURIComponent("" + localOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseActivitiesForLocalOffice(_response);
        });
    }

    protected processGetCaseActivitiesForLocalOffice(response: Response): Promise<LocalOfficeCaseActivityCheckboxDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeCaseActivityCheckboxDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeCaseActivityCheckboxDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseActivitiesForLocalOffice(body: UpdateLocalOfficeCaseActivitiesDTO | undefined): Promise<LocalOfficeCaseActivityCheckboxDTO[]> {
        let url_ = this.baseUrl + "/LocalOfficeCaseActivityCheckbox/UpdateCaseActivitiesForLocalOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCaseActivitiesForLocalOffice(_response);
        });
    }

    protected processUpdateCaseActivitiesForLocalOffice(response: Response): Promise<LocalOfficeCaseActivityCheckboxDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeCaseActivityCheckboxDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeCaseActivityCheckboxDTO[]>(null as any);
    }
}

export class LocalOfficeUserClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param principalId (optional) 
     * @return Success
     */
    getLocalOfficeUser(principalId: string | undefined): Promise<LocalOfficeUserDTO> {
        let url_ = this.baseUrl + "/LocalOfficeUser/GetLocalOfficeUser?";
        if (principalId === null)
            throw new Error("The parameter 'principalId' cannot be null.");
        else if (principalId !== undefined)
            url_ += "principalId=" + encodeURIComponent("" + principalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocalOfficeUser(_response);
        });
    }

    protected processGetLocalOfficeUser(response: Response): Promise<LocalOfficeUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeUserDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeUserDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createLocalOfficeUser(body: CreateLocalOfficeUserDTO | undefined): Promise<LocalOfficeUserDTO> {
        let url_ = this.baseUrl + "/LocalOfficeUser/CreateLocalOfficeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocalOfficeUser(_response);
        });
    }

    protected processCreateLocalOfficeUser(response: Response): Promise<LocalOfficeUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeUserDTO;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeUserDTO>(null as any);
    }

    /**
     * @param resettlementAgencyId (optional) 
     * @return Success
     */
    getResettlementAgencyLocalOfficeUsers(resettlementAgencyId: number | undefined): Promise<LocalOfficeUserDTO[]> {
        let url_ = this.baseUrl + "/LocalOfficeUser/GetResettlementAgencyLocalOfficeUsers?";
        if (resettlementAgencyId === null)
            throw new Error("The parameter 'resettlementAgencyId' cannot be null.");
        else if (resettlementAgencyId !== undefined)
            url_ += "resettlementAgencyId=" + encodeURIComponent("" + resettlementAgencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResettlementAgencyLocalOfficeUsers(_response);
        });
    }

    protected processGetResettlementAgencyLocalOfficeUsers(response: Response): Promise<LocalOfficeUserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeUserDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeUserDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteLocalOfficeUser(body: InactivateLocalOfficeUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LocalOfficeUser/DeleteLocalOfficeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLocalOfficeUser(_response);
        });
    }

    protected processDeleteLocalOfficeUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfLocalOfficeUserExists(body: LocalOfficeUserExistsDTO | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/LocalOfficeUser/CheckIfLocalOfficeUserExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfLocalOfficeUserExists(_response);
        });
    }

    protected processCheckIfLocalOfficeUserExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    getByEmail(email: string | undefined): Promise<LocalOfficeUser> {
        let url_ = this.baseUrl + "/LocalOfficeUser/GetByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByEmail(_response);
        });
    }

    protected processGetByEmail(response: Response): Promise<LocalOfficeUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocalOfficeUser;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocalOfficeUser>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reactivateLocalOfficeUser(body: InactivateLocalOfficeUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LocalOfficeUser/ReactivateLocalOfficeUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivateLocalOfficeUser(_response);
        });
    }

    protected processReactivateLocalOfficeUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reinviteUser(body: ReinviteUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LocalOfficeUser/ReinviteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReinviteUser(_response);
        });
    }

    protected processReinviteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MouBlobClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param caseNumber (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadBlob(caseNumber: string | undefined, file: FileParameter | undefined): Promise<BlobUploadDTO> {
        let url_ = this.baseUrl + "/MouBlob/UploadBlob?";
        if (caseNumber === null)
            throw new Error("The parameter 'caseNumber' cannot be null.");
        else if (caseNumber !== undefined)
            url_ += "caseNumber=" + encodeURIComponent("" + caseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadBlob(_response);
        });
    }

    protected processUploadBlob(response: Response): Promise<BlobUploadDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlobUploadDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlobUploadDTO>(null as any);
    }

    /**
     * @param filePath (optional) 
     * @return Success
     */
    getBlob(filePath: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/MouBlob/GetBlob?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBlob(_response);
        });
    }

    protected processGetBlob(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class NationalResettlementAgencyClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllNationalResettlementAgencies(): Promise<NationalResettlementAgencyDTO[]> {
        let url_ = this.baseUrl + "/NationalResettlementAgency/GetAllNationalResettlementAgencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllNationalResettlementAgencies(_response);
        });
    }

    protected processGetAllNationalResettlementAgencies(response: Response): Promise<NationalResettlementAgencyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementAgencyDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementAgencyDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createNationalResettlementAgency(body: CreateNationalResettlementAgencyDTO | undefined): Promise<NationalResettlementAgencyDTO> {
        let url_ = this.baseUrl + "/NationalResettlementAgency/CreateNationalResettlementAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNationalResettlementAgency(_response);
        });
    }

    protected processCreateNationalResettlementAgency(response: Response): Promise<NationalResettlementAgencyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementAgencyDTO;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementAgencyDTO>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    checkIfNationalResettlementAgencyExists(name: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/NationalResettlementAgency/CheckIfNationalResettlementAgencyExists?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfNationalResettlementAgencyExists(_response);
        });
    }

    protected processCheckIfNationalResettlementAgencyExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editNationalResettlmentAgency(body: NationalResettlementAgencyDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/NationalResettlementAgency/EditNationalResettlmentAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditNationalResettlmentAgency(_response);
        });
    }

    protected processEditNationalResettlmentAgency(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NationalResettlementUserClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param principalId (optional) 
     * @return Success
     */
    getByPrincipalId(principalId: string | undefined): Promise<NationalResettlementUserDTO> {
        let url_ = this.baseUrl + "/NationalResettlementUser/GetByPrincipalId?";
        if (principalId === null)
            throw new Error("The parameter 'principalId' cannot be null.");
        else if (principalId !== undefined)
            url_ += "principalId=" + encodeURIComponent("" + principalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByPrincipalId(_response);
        });
    }

    protected processGetByPrincipalId(response: Response): Promise<NationalResettlementUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementUserDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementUserDTO>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    getByEmail(email: string | undefined): Promise<NationalResettlementUserDTO> {
        let url_ = this.baseUrl + "/NationalResettlementUser/GetByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByEmail(_response);
        });
    }

    protected processGetByEmail(response: Response): Promise<NationalResettlementUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementUserDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementUserDTO>(null as any);
    }

    /**
     * @return Success
     */
    getAllNationalResettlementUsers(): Promise<NationalResettlementUserDTO[]> {
        let url_ = this.baseUrl + "/NationalResettlementUser/GetAllNationalResettlementUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllNationalResettlementUsers(_response);
        });
    }

    protected processGetAllNationalResettlementUsers(response: Response): Promise<NationalResettlementUserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementUserDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementUserDTO[]>(null as any);
    }

    /**
     * @param agencyId (optional) 
     * @return Success
     */
    getAllNationalResettlementUsersByAgencyId(agencyId: number | undefined): Promise<NationalResettlementUserDTO[]> {
        let url_ = this.baseUrl + "/NationalResettlementUser/GetAllNationalResettlementUsersByAgencyId?";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllNationalResettlementUsersByAgencyId(_response);
        });
    }

    protected processGetAllNationalResettlementUsersByAgencyId(response: Response): Promise<NationalResettlementUserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementUserDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementUserDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteNationalResettlementUser(body: InactivateNationalResettlementUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/NationalResettlementUser/DeleteNationalResettlementUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteNationalResettlementUser(_response);
        });
    }

    protected processDeleteNationalResettlementUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reactivateNationalResettlementUser(body: InactivateNationalResettlementUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/NationalResettlementUser/ReactivateNationalResettlementUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivateNationalResettlementUser(_response);
        });
    }

    protected processReactivateNationalResettlementUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createNationalResettlementInvite(body: CreateNationalResettlementUserDTO | undefined): Promise<NationalResettlementUserDTO> {
        let url_ = this.baseUrl + "/NationalResettlementUser/CreateNationalResettlementInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNationalResettlementInvite(_response);
        });
    }

    protected processCreateNationalResettlementInvite(response: Response): Promise<NationalResettlementUserDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NationalResettlementUserDTO;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NationalResettlementUserDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reinviteUser(body: ReinviteUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/NationalResettlementUser/ReinviteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReinviteUser(_response);
        });
    }

    protected processReinviteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReportsByRoles(body: GetReportsByRolesDTO | undefined): Promise<ReportDTO[]> {
        let url_ = this.baseUrl + "/Report/GetReportsByRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportsByRoles(_response);
        });
    }

    protected processGetReportsByRoles(response: Response): Promise<ReportDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportDTO[]>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReport(reportId: number | undefined): Promise<ReportDTO> {
        let url_ = this.baseUrl + "/Report/GetReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<ReportDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportDTO>(null as any);
    }
}

export class SponsorshipGroupClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTypes(): Promise<SponsorshipGroupTypeDTO[]> {
        let url_ = this.baseUrl + "/SponsorshipGroup/GetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTypes(_response);
        });
    }

    protected processGetTypes(response: Response): Promise<SponsorshipGroupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsorshipGroupTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsorshipGroupTypeDTO[]>(null as any);
    }

    /**
     * @param localOfficeID (optional) 
     * @return Success
     */
    getSponsorshipGroups(localOfficeID: number | undefined): Promise<SponsorshipGroupDTO[]> {
        let url_ = this.baseUrl + "/SponsorshipGroup/GetSponsorshipGroups?";
        if (localOfficeID === null)
            throw new Error("The parameter 'localOfficeID' cannot be null.");
        else if (localOfficeID !== undefined)
            url_ += "localOfficeID=" + encodeURIComponent("" + localOfficeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSponsorshipGroups(_response);
        });
    }

    protected processGetSponsorshipGroups(response: Response): Promise<SponsorshipGroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsorshipGroupDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsorshipGroupDTO[]>(null as any);
    }

    /**
     * @param localOfficeID (optional) 
     * @return Success
     */
    getSponsorshipGroupsList(localOfficeID: number | undefined): Promise<SponsorshipGroupDTO[]> {
        let url_ = this.baseUrl + "/SponsorshipGroup/GetSponsorshipGroupsList?";
        if (localOfficeID === null)
            throw new Error("The parameter 'localOfficeID' cannot be null.");
        else if (localOfficeID !== undefined)
            url_ += "localOfficeID=" + encodeURIComponent("" + localOfficeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSponsorshipGroupsList(_response);
        });
    }

    protected processGetSponsorshipGroupsList(response: Response): Promise<SponsorshipGroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsorshipGroupDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsorshipGroupDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteSponsorshipGroup(body: SponsorshipGroupDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SponsorshipGroup/DeleteSponsorshipGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSponsorshipGroup(_response);
        });
    }

    protected processDeleteSponsorshipGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteSponsorshipGroupVolunteer(body: SponsorshipGroupVolunteerDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SponsorshipGroup/DeleteSponsorshipGroupVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSponsorshipGroupVolunteer(_response);
        });
    }

    protected processDeleteSponsorshipGroupVolunteer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateSponsorshipGroup(body: SponsorshipGroupDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SponsorshipGroup/UpdateSponsorshipGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSponsorshipGroup(_response);
        });
    }

    protected processUpdateSponsorshipGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateSponsorshipGroupVolunteer(body: SponsorshipGroupVolunteerDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/SponsorshipGroup/UpdateSponsorshipGroupVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSponsorshipGroupVolunteer(_response);
        });
    }

    protected processUpdateSponsorshipGroupVolunteer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SponsorshipGroupCommunityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCommunityTypes(): Promise<SponsorshipGroupCommunityTypeDTO[]> {
        let url_ = this.baseUrl + "/SponsorshipGroupCommunity/GetCommunityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommunityTypes(_response);
        });
    }

    protected processGetCommunityTypes(response: Response): Promise<SponsorshipGroupCommunityTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SponsorshipGroupCommunityTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SponsorshipGroupCommunityTypeDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getFaithCommunityTypes(): Promise<FaithCommunityTypeDTO[]> {
        let url_ = this.baseUrl + "/SponsorshipGroupCommunity/GetFaithCommunityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFaithCommunityTypes(_response);
        });
    }

    protected processGetFaithCommunityTypes(response: Response): Promise<FaithCommunityTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FaithCommunityTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FaithCommunityTypeDTO[]>(null as any);
    }
}

export class StateClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllStates(): Promise<StateDTO[]> {
        let url_ = this.baseUrl + "/State/GetAllStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllStates(_response);
        });
    }

    protected processGetAllStates(response: Response): Promise<StateDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StateDTO[]>(null as any);
    }
}

export class VolunteerClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllVolunteers(): Promise<VolunteerDTO[]> {
        let url_ = this.baseUrl + "/Volunteer/GetAllVolunteers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllVolunteers(_response);
        });
    }

    protected processGetAllVolunteers(response: Response): Promise<VolunteerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerDTO[]>(null as any);
    }

    /**
     * @param localOfficeID (optional) 
     * @return Success
     */
    getLocalOfficeVolunteers(localOfficeID: number | undefined): Promise<VolunteerListDTO[]> {
        let url_ = this.baseUrl + "/Volunteer/GetLocalOfficeVolunteers?";
        if (localOfficeID === null)
            throw new Error("The parameter 'localOfficeID' cannot be null.");
        else if (localOfficeID !== undefined)
            url_ += "localOfficeID=" + encodeURIComponent("" + localOfficeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocalOfficeVolunteers(_response);
        });
    }

    protected processGetLocalOfficeVolunteers(response: Response): Promise<VolunteerListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerListDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerListDTO[]>(null as any);
    }

    /**
     * @param resettlementAgencyId (optional) 
     * @return Success
     */
    getResettlementAgencyVolunteers(resettlementAgencyId: number | undefined): Promise<VolunteerListDTO[]> {
        let url_ = this.baseUrl + "/Volunteer/GetResettlementAgencyVolunteers?";
        if (resettlementAgencyId === null)
            throw new Error("The parameter 'resettlementAgencyId' cannot be null.");
        else if (resettlementAgencyId !== undefined)
            url_ += "resettlementAgencyId=" + encodeURIComponent("" + resettlementAgencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResettlementAgencyVolunteers(_response);
        });
    }

    protected processGetResettlementAgencyVolunteers(response: Response): Promise<VolunteerListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerListDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerListDTO[]>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    checkIfVolunteerEmailExists(email: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Volunteer/CheckIfVolunteerEmailExists?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfVolunteerEmailExists(_response);
        });
    }

    protected processCheckIfVolunteerEmailExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createVolunteer(body: VolunteerDTO | undefined): Promise<VolunteerDTO> {
        let url_ = this.baseUrl + "/Volunteer/CreateVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVolunteer(_response);
        });
    }

    protected processCreateVolunteer(response: Response): Promise<VolunteerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerDTO;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVolunteer(body: VolunteerDTO | undefined): Promise<VolunteerDTO> {
        let url_ = this.baseUrl + "/Volunteer/UpdateVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVolunteer(_response);
        });
    }

    protected processUpdateVolunteer(response: Response): Promise<VolunteerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    deleteVolunteer(body: InactivateVolunteerDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Volunteer/DeleteVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVolunteer(_response);
        });
    }

    protected processDeleteVolunteer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reactivateVolunteer(body: InactivateVolunteerDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Volunteer/ReactivateVolunteer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivateVolunteer(_response);
        });
    }

    protected processReactivateVolunteer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param principalId (optional) 
     * @return Success
     */
    getVolunteerByPrincipalId(principalId: string | undefined): Promise<VolunteerDTO> {
        let url_ = this.baseUrl + "/Volunteer/GetVolunteerByPrincipalId?";
        if (principalId === null)
            throw new Error("The parameter 'principalId' cannot be null.");
        else if (principalId !== undefined)
            url_ += "principalId=" + encodeURIComponent("" + principalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVolunteerByPrincipalId(_response);
        });
    }

    protected processGetVolunteerByPrincipalId(response: Response): Promise<VolunteerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VolunteerDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VolunteerDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createVolunteerInvite(body: CreateVolunteerDTO | undefined): Promise<InvitationResponse> {
        let url_ = this.baseUrl + "/Volunteer/CreateVolunteerInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateVolunteerInvite(_response);
        });
    }

    protected processCreateVolunteerInvite(response: Response): Promise<InvitationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitationResponse;
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    reinviteUser(body: ReinviteUserDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Volunteer/ReinviteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReinviteUser(_response);
        });
    }

    protected processReinviteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface BlobUploadDTO {
    path?: string | undefined;
    fileName?: string | undefined;
}

export interface Case {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    number?: string | undefined;
    size?: number;
    statusID?: number;
    status?: CaseStatus;
    clientDOA?: Date | undefined;
    countryOfOriginID?: number;
    countryOfOrigin?: Country;
    clientNativeLanguageID?: number;
    clientNativeLanguage?: Language;
    otherLanguagesSpoken?: SpokenLanguage[] | undefined;
    clientHasUSTie?: boolean;
    clientUSTieName?: string | undefined;
    clientUSTiePhoneNumber?: string | undefined;
    clientUSTiePrimaryLanguageID?: number | undefined;
    clientUSTiePrimaryLanguage?: Language;
    caseSponsorshipGroups?: CaseSponsorshipGroup[] | undefined;
    caseVolunteers?: CaseVolunteer[] | undefined;
    localOfficeID?: number;
    localOffice?: LocalOffice;
    familyMembers?: FamilyMember[] | undefined;
    grantTag?: string | undefined;
    grantTagOther?: string | undefined;
}

export interface CaseActivityCheckboxDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    section?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
    daysToComplete?: number | undefined;
    useWorkingDays?: boolean;
}

export interface CaseDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    number?: string | undefined;
    statusID?: number;
    status?: CaseStatusDTO;
    size?: number;
    clientDOA?: Date | undefined;
    countryOfOrigin?: CountryDTO;
    clientNativeLanguage?: LanguageDTO;
    otherLanguagesSpoken?: SpokenLanguageDTO[] | undefined;
    clientHasUSTie?: boolean;
    clientUSTieName?: string | undefined;
    clientUSTiePhoneNumber?: string | undefined;
    clientUSTiePrimaryLanguage?: LanguageDTO;
    caseSponsorshipGroups?: CaseSponsorshipGroupDTO[] | undefined;
    volunteers?: CaseVolunteerDTO[] | undefined;
    localOfficeID?: number;
    localOffice?: LocalOfficeDTO;
    familyMembers?: FamilyMemberDTO[] | undefined;
    grantTag?: string | undefined;
    grantTagOther?: string | undefined;
}

export interface CaseSponsorshipGroup {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    caseID?: number;
    case?: Case;
    sponsorshipGroupID?: number | undefined;
    sponsorshipGroup?: SponsorshipGroup;
    typeID?: number;
    type?: SponsorshipGroupType;
    signedMoU?: boolean | undefined;
    mouFilePath?: string | undefined;
    coreServices?: number;
    requiredCashContribution?: number | undefined;
    requiredCashContributionNA?: boolean;
    requiredInKindContributions?: string | undefined;
    requiredInKindContributionsNA?: boolean;
    volunteerActivityResponsibilities?: string | undefined;
    dateOfMatch?: Date | undefined;
    allCoreMembersTrained?: boolean;
    allCoreMembersProvidedBackgroundChecks?: boolean;
    commitmentDurationMonths?: number;
    commitmentDurationMonthsMax?: number;
}

export interface CaseSponsorshipGroupDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    caseID?: number;
    sponsorshipGroupID?: number | undefined;
    sponsorshipGroup?: SponsorshipGroupDTO;
    typeID?: number;
    type?: SponsorshipGroupTypeDTO;
    pairedWithCommunitySponsorship?: boolean;
    signedMoU?: boolean | undefined;
    mouFilePath?: string | undefined;
    mouFilename?: string | undefined;
    coreServices?: number;
    requiredCashContribution?: number | undefined;
    requiredCashContributionNA?: boolean;
    requiredInKindContributions?: string | undefined;
    requiredInKindContributionsNA?: boolean;
    volunteerActivityResponsibilities?: string | undefined;
    dateOfMatch?: Date | undefined;
    allCoreMembersTrained?: boolean;
    allCoreMembersProvidedBackgroundChecks?: boolean;
    commitmentDurationMonths?: number;
    commitmentDurationMonthsMax?: number;
}

export interface CaseStatus {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface CaseStatusDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface CaseVolunteer {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    caseID?: number;
    case?: Case;
    volunteerID?: number;
    dateOfMatch?: Date | undefined;
    timeCommitment?: number | undefined;
    volunteer?: Volunteer;
    isDeleted?: boolean;
}

export interface CaseVolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    caseID?: number;
    volunteerID?: number;
    dateOfMatch?: Date | undefined;
    timeCommitment?: number | undefined;
    volunteer?: VolunteerDTO;
    isDeleted?: boolean;
}

export interface Country {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface CountryDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface CreateCaseActivityDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    caseId?: number;
    caseNumber?: string | undefined;
    volunteer?: VolunteerDTO;
    volunteerId?: number;
    createdDate?: Date;
    financialDontationMade?: boolean;
    financialDonationAmount?: number;
    financialDonationPurpose?: string | undefined;
    otherCaseActivityInformation?: string | undefined;
    caseActivityTasks?: CreateCaseActivityTaskDTO[] | undefined;
}

export interface CreateCaseActivityTaskDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    interpreterUsed?: boolean;
    interpreterType?: string | undefined;
    hoursSpent?: number;
    minutesSpent?: number;
    activityDate?: Date;
    caseActivityCheckboxId?: number;
    otherCaseActivityTaskText?: string | undefined;
    inKindDonations?: InKindDonationDTO[] | undefined;
    inKindDonationTotal?: number;
    inKindReceiptFileName?: string | undefined;
    inKindReceiptFilePath?: string | undefined;
    inKindDonationMade?: boolean;
    transportationProvided?: boolean;
    transportationMileage?: number;
    caseNoteDocumentation?: string | undefined;
}

export interface CreateCaseDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    number?: string | undefined;
    statusID?: number;
    status?: CaseStatusDTO;
    size?: number;
    clientDOA?: Date | undefined;
    countryOfOriginID?: number;
    clientNativeLanguageID?: number;
    otherLanguagesSpoken?: SpokenLanguageDTO[] | undefined;
    clientHasUSTie?: boolean;
    clientUSTieName?: string | undefined;
    clientUSTiePhoneNumber?: string | undefined;
    clientUSTiePrimaryLanguageID?: number | undefined;
    caseSponsorshipGroups?: CaseSponsorshipGroupDTO[] | undefined;
    matchedWithCommunitySponsorship?: boolean;
    localOfficeID?: number;
    caseVolunteers?: CaseVolunteerDTO[] | undefined;
    familyMembers?: FamilyMemberDTO[] | undefined;
    grantTag?: string | undefined;
    grantTagOther?: string | undefined;
}

export interface CreateLocalOfficeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    adddress2?: string | undefined;
    city?: string | undefined;
    stateID?: number;
    postalCode?: string | undefined;
    localOfficeUser?: CreateLocalOfficeUserDTO;
    nationalResettlementAgencyID?: number;
}

export interface CreateLocalOfficeUserDTO {
    principalId?: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    localOfficeId?: number;
}

export interface CreateNationalResettlementAgencyDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface CreateNationalResettlementUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationalResettlementAgencyId?: number;
    email?: string | undefined;
}

export interface CreateVolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    principalId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    postalCode?: string | undefined;
    primaryLanguageId?: number | undefined;
    engagementCountId?: number | undefined;
    cellPhone?: string | undefined;
    localOfficeId?: number;
    volunteerOtherLanguages?: VolunteerOtherLanguageDTO[] | undefined;
    registrationComplete?: boolean;
    isGroupLeader?: boolean;
}

export interface EducationLevel {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EducationLevelDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EmbedInfoDTO {
    workspaceId?: string | undefined;
    reportId?: string | undefined;
}

export interface EmbedParams {
    type?: string | undefined;
    embedReport?: EmbedReport[] | undefined;
    embedToken?: EmbedToken;
}

export interface EmbedReport {
    reportId?: string;
    reportName?: string | undefined;
    embedUrl?: string | undefined;
}

export interface EmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;
}

export interface EmploymentType {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EmploymentTypeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EngagementCount {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EngagementCountDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface Ethnicity {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface EthnicityDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface FaithCommunityType {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    faithType?: string | undefined;
}

export interface FaithCommunityTypeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    faithType?: string | undefined;
}

export interface FamilyMember {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    stateID?: number;
    state?: State;
    zipCode?: string | undefined;
    contactNumber?: string | undefined;
    isPrimary?: boolean;
    caseID?: number | undefined;
}

export interface FamilyMemberDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    stateID?: number;
    state?: StateDTO;
    zipCode?: string | undefined;
    contactNumber?: string | undefined;
    isPrimary?: boolean;
    caseID?: number | undefined;
}

export interface Gender {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface GenderDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    value?: string | undefined;
}

export interface GetReportsByRolesDTO {
    roles?: string[] | undefined;
}

export interface GetVolunteerCasesDTO {
    volunteerID?: number;
    localOfficeID?: number;
}

export interface ImmigrationStory {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    story?: string | undefined;
    sortOrder?: number;
}

export interface ImmigrationStoryDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    story?: string | undefined;
    sortOrder?: number;
}

export interface InKindDonationDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    amount?: number;
}

export interface InactivateLocalOfficeUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    principalId?: string;
}

export interface InactivateNationalResettlementUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    nationalResettlementAgencyId?: number;
    principalId?: string;
}

export interface InactivateVolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    principalId?: string;
}

export interface InvitationResponse {
    invitedUserEmailAddress?: string | undefined;
    inviteRedirectUrl?: string | undefined;
    sendInvitationMessage?: boolean;
    inviteRedeemUrl?: string | undefined;
    invitedUser?: InvitedUser;
}

export interface InvitedUser {
    id?: string | undefined;
    isNew?: boolean;
}

export interface Language {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    spokenLanguages?: SpokenLanguage[] | undefined;
    volunteerOtherLanguages?: VolunteerOtherLanguage[] | undefined;
}

export interface LanguageDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface LocalOffice {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    adddress2?: string | undefined;
    city?: string | undefined;
    stateID?: number;
    state?: State;
    postalCode?: string | undefined;
    isDeleted: boolean;
    isWelcomeCorp: boolean;
    localOfficeLocalOfficeUsers?: LocalOfficeLocalOfficeUser[] | undefined;
    volunteers?: LocalOfficeVolunteer[] | undefined;
    cases?: Case[] | undefined;
    nationalResettlementAgencyId?: number;
    nationalResettlementAgency?: NationalResettlementAgency;
    createDate?: Date;
}

export interface LocalOfficeActivityCheckboxBySectionDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    section?: string | undefined;
}

export interface LocalOfficeCaseActivityCheckboxDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    localOffice?: LocalOfficeDTO;
    caseActivityCheckBoxId?: number;
    caseActivityCheckbox?: CaseActivityCheckboxDTO;
    active?: boolean;
}

export interface LocalOfficeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: StateDTO;
    postalCode?: string | undefined;
    isWelcomeCorp?: boolean;
    nationalResettlementAgency?: NationalResettlementAgencyDTO;
}

export interface LocalOfficeLocalOfficeUser {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    localOfficeUserId?: number;
    isActive?: boolean;
    localOffice?: LocalOffice;
    localOfficeUser?: LocalOfficeUser;
}

export interface LocalOfficeLocalOfficeUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    localOfficeUserId?: number;
    isActive?: boolean;
    localOffice?: LocalOfficeDTO;
}

export interface LocalOfficeUser {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    principalId: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    isPrimary?: boolean;
    isDeleted: boolean;
    localOfficeLocalOfficeUsers?: LocalOfficeLocalOfficeUser[] | undefined;
    createDate: Date;
}

export interface LocalOfficeUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    principalId: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    localOfficeLocalOfficeUsers?: LocalOfficeLocalOfficeUserDTO[] | undefined;
    localOffice?: LocalOfficeDTO;
    isActive?: boolean;
}

export interface LocalOfficeUserExistsDTO {
    email?: string | undefined;
    localOfficeId?: number;
}

export interface LocalOfficeVolunteer {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    volunteerId?: number;
    isActive?: boolean;
    localOffice?: LocalOffice;
    volunteer?: Volunteer;
}

export interface LocalOfficeVolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    localOfficeId?: number;
    volunteerId?: number;
    isActive?: boolean;
    localOffice?: LocalOfficeDTO;
}

export interface NationalResettlementAgency {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    createDate?: Date;
    nationalResettlementAgencyNationalResettlementUsers?: NationalResettlementAgencyNationalResettlementUser[] | undefined;
}

export interface NationalResettlementAgencyDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface NationalResettlementAgencyNationalResettlementUser {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    nationalResettlementAgencyId?: number;
    nationalResettlementUserId?: number;
    isActive?: boolean;
    nationalResettlementAgency?: NationalResettlementAgency;
    nationalResettlementUser?: NationalResettlementUser;
}

export interface NationalResettlementAgencyNationalResettlementUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    nationalResettlementAgencyId?: number;
    nationalResettlementUserId?: number;
    isActive?: boolean;
    nationalResettlementAgency?: NationalResettlementAgencyDTO;
}

export interface NationalResettlementUser {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationalResettlementAgencyNationalResettlementUsers?: NationalResettlementAgencyNationalResettlementUser[] | undefined;
    email: string;
    principalId: string;
    isDeleted: boolean;
    createDate?: Date;
}

export interface NationalResettlementUserDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nationalResettlementAgencyNationalResettlementUsers?: NationalResettlementAgencyNationalResettlementUserDTO[] | undefined;
    email?: string | undefined;
    isActive?: boolean;
    nationalResettlementAgency?: NationalResettlementAgencyDTO;
    principalId?: string;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ReinviteUserDTO {
    principalId?: string;
}

export interface ReportDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    reportName?: string | undefined;
    workspaceId?: string | undefined;
    reportId?: string | undefined;
    tableName?: string | undefined;
    reportReportRoles?: ReportReportRoleDTO[] | undefined;
}

export interface ReportReportRoleDTO {
    reportRoleId?: number;
    reportRole?: ReportRoleDTO;
}

export interface ReportRoleDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    roleName?: string | undefined;
}

export interface SpokenLanguage {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    caseId?: number;
    languageId?: number;
    language?: Language;
}

export interface SpokenLanguageDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    caseId?: number;
    languageId?: number;
    language?: LanguageDTO;
}

export interface SponsorshipGroup {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    totalGroupMembers?: number;
    isDeleted?: boolean;
    sponsorshipGroupCommunityTypeID?: number | undefined;
    sponsorshipGroupCommunityType?: SponsorshipGroupCommunityType;
    faithCommunityTypeID?: number | undefined;
    faithCommunityType?: FaithCommunityType;
    faithCommunityOther?: string | undefined;
    sponsorshipGroupVolunteers?: SponsorshipGroupVolunteer[] | undefined;
    localOfficeID?: number;
    localOffice?: LocalOffice;
}

export interface SponsorshipGroupCommunityType {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    type?: string | undefined;
}

export interface SponsorshipGroupCommunityTypeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    type?: string | undefined;
}

export interface SponsorshipGroupDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
    totalGroupMembers?: number;
    isExisting?: boolean;
    isDeleted?: boolean;
    sponsorshipGroupCommunityTypeID?: number | undefined;
    sponsorshipGroupCommunityType?: SponsorshipGroupCommunityTypeDTO;
    faithCommunityTypeID?: number | undefined;
    faithCommunityType?: FaithCommunityTypeDTO;
    faithCommunityOther?: string | undefined;
    sponsorshipGroupVolunteers?: SponsorshipGroupVolunteerDTO[] | undefined;
    associatedCases?: string[] | undefined;
    associatedTypes?: string[] | undefined;
    localOfficeID?: number;
    localOffice?: LocalOfficeDTO;
}

export interface SponsorshipGroupType {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    type?: string | undefined;
}

export interface SponsorshipGroupTypeDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    type?: string | undefined;
}

export interface SponsorshipGroupVolunteer {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    sponsorshipGroupID?: number;
    sponsorshipGroup?: SponsorshipGroup;
    volunteerID?: number;
    volunteer?: Volunteer;
    isGroupLeader?: boolean;
    isDeleted?: boolean;
}

export interface SponsorshipGroupVolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    sponsorshipGroupID?: number;
    volunteerID?: number;
    volunteer?: VolunteerDTO;
    isGroupLeader?: boolean;
    isDeleted?: boolean;
}

export interface State {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface StateDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    name?: string | undefined;
}

export interface UpdateLocalOfficeCaseActivitiesDTO {
    localOfficeId?: number;
    isWelcomeCorp?: boolean;
    localOfficeCaseActivities?: LocalOfficeCaseActivityCheckboxDTO[] | undefined;
}

export interface Volunteer {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    principalId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted: boolean;
    email: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    state?: State;
    postalCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderId?: number | undefined;
    gender?: Gender;
    ethnicityId?: number | undefined;
    ethnicity?: Ethnicity;
    primaryLanguageId?: number | undefined;
    primaryLanguage?: Language;
    volunteerOtherLanguages?: VolunteerOtherLanguage[] | undefined;
    educationLevelId?: number | undefined;
    educationLevel?: EducationLevel;
    employmentTypeId?: number | undefined;
    employmentType?: EmploymentType;
    employmentTypeNotes?: string | undefined;
    engagementCountId?: number | undefined;
    engagementCount?: EngagementCount;
    cellPhone?: string | undefined;
    localOfficeVolunteers?: LocalOfficeVolunteer[] | undefined;
    immigrationStoryId?: number | undefined;
    immigrationStory?: ImmigrationStory;
    immigrationStoryCountry?: string | undefined;
    isRefugee?: boolean;
    registrationComplete: boolean;
    createDate?: Date;
}

export interface VolunteerDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    principalId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    stateId?: number | undefined;
    postalCode?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderId?: number | undefined;
    ethnicityId?: number | undefined;
    primaryLanguageId?: number | undefined;
    educationLevelId?: number | undefined;
    employmentTypeId?: number | undefined;
    employmentType?: EmploymentTypeDTO;
    employmentTypeNotes?: string | undefined;
    engagementCountId?: number | undefined;
    cellPhone?: string | undefined;
    localOfficeVolunteers?: LocalOfficeVolunteerDTO[] | undefined;
    immigrationStoryId?: number | undefined;
    immigrationStory?: ImmigrationStoryDTO;
    volunteerOtherLanguages?: VolunteerOtherLanguageDTO[] | undefined;
    immigrationStoryCountry?: string | undefined;
    registrationComplete?: boolean;
    isGroupLeader?: boolean;
    isRefugee?: boolean;
}

export interface VolunteerListDTO {
    id?: number;
    lastModifiedBy?: string | undefined;
    principalId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    email?: string | undefined;
    localOffice?: LocalOfficeDTO;
    localOfficeVolunteers?: LocalOfficeVolunteerDTO[] | undefined;
}

export interface VolunteerOtherLanguage {
    id: number;
    created?: Date;
    modified?: Date;
    lastModifiedBy?: string | undefined;
    volunteerId?: number;
    volunteer?: Volunteer;
    languageId?: number;
    language?: Language;
}

export interface VolunteerOtherLanguageDTO {
    volunteerId?: number;
    languageId?: number;
    language?: LanguageDTO;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}